export default __webpack_public_path__ + "static/media/otkritie.ce90c9c4.webp";